<template>
    <asli-form @submitted="submit">
        <div class="flex flex-col min-h-[55vh]">
            <asli-form-section :title="`Thank you ${personalDetails?.first_name}!`">
                <div class="flex flex-col gap-6">
                    <div class="bg-lighterGreen flex flex-col gap-4 p-8 mt-4 rounded-md">
                        <p class="text-green-500 text-sm">You have successfully updated your marketing preferences.</p>
                    </div>
                </div>
            </asli-form-section>
            <div class="flex-grow"></div>
            <form-buttons
                class="flex-col items-center md:items-end mt-20"
                @back="goBack"
                continueButtonTitle="Finish"
                prevent-scroll
            />
        </div>
    </asli-form>
</template>

<script lang="ts" setup>
import { AsliFormSection, AsliForm } from "@mbs-npm/anpost-ui";
import FormButtons from "@/components/FormButtons.vue";
import { useProposalStore } from "@/stores/risk/risk";
import { ROUTE_NAMES } from "@/router/types";
import { useRouter } from "vue-router";
import { computed } from "vue";

const router = useRouter();
const proposalStore = useProposalStore();

const proposal = computed(() => proposalStore?.proposal);
const risk = computed(() => proposal.value?.risk);

const personalDetails = computed(() => risk.value?.proposer?.personal_details);

function goBack() {
    router.push({
        name: ROUTE_NAMES.MarketingPreferences,
        query: {
            uuid: proposalStore.proposal.uuid
        }
    });
}

function submit() {
    router.push({
        name: ROUTE_NAMES.MarketingPreferencesLogin
    });
}
</script>
